import * as React from "react";

const DownArrow = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6">
  <path id="Icon_ionic-ios-arrow-down" data-name="Icon ionic-ios-arrow-down" d="M12.19,15.438l4.537-3.971a.943.943,0,0,1,1.211,0,.691.691,0,0,1,0,1.062l-5.141,4.5a.947.947,0,0,1-1.183.022L6.438,12.532a.689.689,0,0,1,0-1.062.943.943,0,0,1,1.211,0Z" transform="translate(-6.188 -11.246)" fill="#85888A"/>
</svg>

);

export default DownArrow;
